import { render, staticRenderFns } from "../trips/tripsForm.html?vue&type=template&id=51cc123a&scoped=true&external"
import script from "../trips/tripsForm.js?vue&type=script&lang=js&external"
export * from "../trips/tripsForm.js?vue&type=script&lang=js&external"
import style0 from "../trips/tripsForm.css?vue&type=style&index=0&id=51cc123a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc123a",
  null
  
)

export default component.exports